import useSearchResult from "data-lake/preview/hooks/useSearchResult";
import usePluginEntities from "hooks/usePluginEntities";
const isDataLakeResults = (dataLakePlugins, searchTypeResult) => dataLakePlugins.some(({ searchType }) => searchTypeResult.type === searchType);
const identifyErrors = (searchErrors, queryErrors) => {
  if ((searchErrors == null ? void 0 : searchErrors.length) > 0) {
    return searchErrors;
  }
  if ((queryErrors == null ? void 0 : queryErrors.length) > 0) {
    return queryErrors;
  }
  return [];
};
const useWidgetResults = (search) => {
  var _a, _b;
  const { result: searchResult } = (_a = useSearchResult()) != null ? _a : {};
  const activeQuery = search == null ? void 0 : search.queries.first();
  const activeQueryId = activeQuery == null ? void 0 : activeQuery.id;
  const dataLakePlugins = usePluginEntities("dataLakeStorageTypes");
  const query = (_b = searchResult == null ? void 0 : searchResult.results) == null ? void 0 : _b[activeQueryId];
  const errors = identifyErrors(searchResult == null ? void 0 : searchResult.errors, query == null ? void 0 : query.errors);
  const searchTypeResults = query == null ? void 0 : query.searchTypes[activeQuery.searchTypes[0].id];
  const result = { widgetData: void 0, errors, executedAt: query == null ? void 0 : query.timestamp, duration: query == null ? void 0 : query.duration };
  if (!search || !activeQueryId || !searchTypeResults || !isDataLakeResults(dataLakePlugins, searchTypeResults)) {
    return result;
  }
  return {
    ...result,
    widgetData: searchTypeResults
  };
};
export default useWidgetResults;
